import type { FlujoCapturaRetroalimentacion, OpcionEstadoAnimo } from './tipos';

export const FLUJOS_CAPTURA_RETROALIMENTACION: readonly FlujoCapturaRetroalimentacion[] = [
  'estado_animo',
  'buzon_ideas',
  'nps',
] as const;

export const MAXIMO_COMENTARIO_BREVE_RETROALIMENTACION = 140;
export const MAXIMO_IDEA_RETROALIMENTACION = 280;
export const DIAS_MINIMOS_ENTRE_ENCUESTAS_NPS = 30;
export const HABILITAR_NPS_AUTOMATICO = false;
export const PUNTUACION_NPS_MINIMA = 1;
export const PUNTUACION_NPS_MAXIMA = 10;

export const OPCIONES_ESTADO_ANIMO: readonly OpcionEstadoAnimo[] = [
  { id: 'excelente', etiqueta: 'Excelente', emoji: '😁', descripcion: 'Todo va muy bien hoy.' },
  { id: 'bien', etiqueta: 'Bien', emoji: '🙂', descripcion: 'La operación va fluida.' },
  { id: 'neutral', etiqueta: 'Neutral', emoji: '😐', descripcion: 'Nada crítico, nada destacado.' },
  { id: 'agotado', etiqueta: 'Agotado', emoji: '😮‍💨', descripcion: 'El día se siente pesado.' },
  { id: 'frustrado', etiqueta: 'Frustrado', emoji: '😣', descripcion: 'Algo está generando fricción.' },
] as const;
